/**
 * Gets the browser's timezone offset in GMT format.
 *
 * @returns {string} The timezone offset in the format "GMT+/-hours".
 */
export const getBrowserGMTTimezone = () => {
    const MINUTES_IN_HOUR = 60;
    const offset = new Date().getTimezoneOffset(); // in minutes
    const hours = Math.abs(offset) / MINUTES_IN_HOUR;
    const sign = offset > 0 ? '-' : '+';
    return `GMT${sign}${hours}`;
};

export const getBrowserTimezoneName = () => {
    const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
    if (timeZone === 'Europe/Kiev' || timeZone === 'Europe/Kyev') {
        return 'Europe/Kyiv';
    }
    return timeZone;
};

export const formatSecondsToMinutes = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
};
